import { genericCallWithBody, genericCallWithOutBody } from './Networking';

export async function saveContact (model:any) {
    let method = 'POST';
    let apiName = 'Contact/SaveContactOnline';

    let response = await genericCallWithBody(method, apiName, model);
    return response;
}

export const inactiveAndActiveContact = async (ContactId: any) => {

    let params = {
        ContactId: ContactId
    }
    var apiName = 'Contact/InactiveContact';
    let response = await genericCallWithOutBody(apiName, params);
    return response;
}